"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("@pbl/pbl-react-core/lib/models/draws/types");
var types_2 = require("@pbl/pbl-react-core/lib/models/reward/types");
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var action_type_util_1 = require("../../action-type.util");
var INITIAL_STATE = {
    loading: false,
    rewardsList: [],
    allDraws: [],
    selectedReward: null,
    activeDraw: null,
    page: {},
    errorMessage: null,
    entries: 0,
    freeEntries: 0,
    freeEntriesRequestSubmission: null
};
exports.default = (function (state, action) {
    if (state === void 0) { state = INITIAL_STATE; }
    switch (action.type) {
        case (0, action_type_util_1.REQUEST)(types_2.GET_REWARD):
        case (0, action_type_util_1.REQUEST)(types_2.GET_REWARD_WITH_FREQUENCY_CAP):
        case (0, action_type_util_1.REQUEST)(types_2.GET_ACTIVE_DRAW):
        case (0, action_type_util_1.REQUEST)(types_2.GET_REWARD_LIST):
        case (0, action_type_util_1.REQUEST)(types_2.GET_ALL_DRAWS):
        case (0, action_type_util_1.REQUEST)(types_2.FETCH_ENTRIES):
        case (0, action_type_util_1.REQUEST)(types_2.FETCH_FREE_ENTRIES):
        case (0, action_type_util_1.REQUEST)(types_2.REDEEM_REWARD):
        case (0, action_type_util_1.REQUEST)(types_1.CLAIM_FREE_ENTRY):
            return __assign(__assign({}, state), { loading: true });
        case (0, action_type_util_1.SUCCESS)(types_2.GET_REWARD):
            return __assign(__assign({}, state), { loading: false, errorMessage: null, selectedReward: action.payload });
        case (0, action_type_util_1.SUCCESS)(types_2.GET_REWARD_WITH_FREQUENCY_CAP):
            return __assign(__assign({}, state), { loading: false, errorMessage: null, selectedReward: action.payload });
        case (0, action_type_util_1.SUCCESS)(types_2.GET_ACTIVE_DRAW):
            return __assign(__assign({}, state), { loading: false, errorMessage: null, activeDraw: action.payload });
        case (0, action_type_util_1.SUCCESS)(types_2.GET_REWARD_LIST):
            return __assign(__assign({}, state), { loading: false, errorMessage: null, rewardsList: action.payload });
        case (0, action_type_util_1.SUCCESS)(types_2.GET_ALL_DRAWS):
            return __assign(__assign({}, state), { loading: false, errorMessage: null, allDraws: action.payload.content, page: action.payload.page });
        case (0, action_type_util_1.SUCCESS)(types_2.FETCH_FREE_ENTRIES):
            return __assign(__assign({}, state), { loading: false, freeEntries: action.payload });
        case (0, action_type_util_1.SUCCESS)(types_2.REDEEM_REWARD):
            return __assign(__assign({}, state), { loading: false });
        case (0, action_type_util_1.SUCCESS)(types_1.CLAIM_FREE_ENTRY):
            return __assign(__assign({}, state), { loading: false, freeEntriesRequestSubmission: (0, moment_timezone_1.default)() });
        case types_2.RESET_REWARD:
            return __assign({}, INITIAL_STATE);
        case types_2.FETCH_ENTRIES:
            return __assign(__assign({}, state), { loading: false, entries: action.payload });
        case (0, action_type_util_1.FAILURE)(types_2.GET_REWARD):
        case (0, action_type_util_1.FAILURE)(types_2.GET_REWARD_WITH_FREQUENCY_CAP):
        case (0, action_type_util_1.FAILURE)(types_2.GET_ACTIVE_DRAW):
        case (0, action_type_util_1.FAILURE)(types_2.GET_REWARD_LIST):
        case (0, action_type_util_1.FAILURE)(types_2.GET_ALL_DRAWS):
        case (0, action_type_util_1.FAILURE)(types_2.FETCH_ENTRIES):
        case (0, action_type_util_1.FAILURE)(types_2.FETCH_FREE_ENTRIES):
        case (0, action_type_util_1.FAILURE)(types_2.REDEEM_REWARD):
        case (0, action_type_util_1.FAILURE)(types_1.CLAIM_FREE_ENTRY):
            return __assign(__assign({}, state), { loading: false, errorMessage: action.payload });
        default:
            return state;
    }
});
//# sourceMappingURL=reducer.js.map